export default __webpack_public_path__ + "pacer-bottom-globe.png";